// extracted by mini-css-extract-plugin
export var active = "_kx-2";
export var recordingDot = "_kx-1";
export var recordingIndicator = "_kx-0";